import React, { useCallback, useState } from "react";
import { ToastDurations, ToastMessageType, ToastNotificationModel } from "Shared/Components/Toast";

import { M365PulseToast } from "Shared/Components/Toast/M365PulseToast";
import { useRootStore } from "Store/RootStore";
import { useToastController } from "@fluentui/react-components";

export const useToast = (id?: string) => {
    const defaultToasterId = useRootStore("toasterId");
    const toasterId = id ?? defaultToasterId;
    const { dispatchToast, updateToast } = useToastController(toasterId);
    const [toastId, setToastId] = useState(0);
    const toastDuration = useCallback((duration?: ToastDurations) => {
        const durationType = duration;
        if (durationType === "Persistent") {
            return -1;
        }
        if (durationType === "Long") {
            return 8000;
        }
        if (durationType === "Max") {
            return 15000;
        }
        return 3000;
    }, []);

    const toastIntent = useCallback((toastType: ToastMessageType) => {
        if (toastType === "customAction") {
            return "info";
        }
        if (toastType === "errorAction") {
            return "error";
        }
        if (toastType === "progress") {
            return undefined;
        }
        return toastType;
    }, []);

    const showToastNotification = useCallback(
        (toastMessage: ToastNotificationModel) => {
            const uniqueId = toastMessage.toastId ? toastMessage.toastId : toastMessage.aggregateType ? toastMessage.aggregateType : String(toastId);
            setToastId(toastId + 1);
            if (toastMessage.toastType !== "progress") {
                dispatchToast(<M365PulseToast toastMessage={toastMessage} />, {
                    toastId: uniqueId,
                    timeout: toastDuration(toastMessage.duration),
                    intent: toastIntent(toastMessage.toastType)
                });
            } else {
                dispatchToast(<M365PulseToast toastMessage={toastMessage} />, {
                    toastId: uniqueId,
                    timeout: toastDuration(toastMessage.duration)
                });
            }
        },
        [dispatchToast, toastDuration, toastIntent, toastId]
    );

    const updateToastNotification = useCallback(
        (toastMessage: ToastNotificationModel) => {
            if (toastMessage.toastId) {
                if (toastMessage.toastType !== "progress") {
                    updateToast({
                        content: <M365PulseToast toastMessage={toastMessage} />,
                        toastId: toastMessage.toastId,
                        timeout: toastDuration(toastMessage.duration),
                        intent: toastIntent(toastMessage.toastType)
                    });
                } else {
                    updateToast({
                        content: <M365PulseToast toastMessage={toastMessage} />,
                        toastId: toastMessage.toastId,
                        timeout: toastDuration(toastMessage.duration)
                    });
                }
            }
        },
        [updateToast, toastDuration, toastIntent]
    );

    return {
        showToastNotification,
        updateToastNotification
    };
};
